<div class="ManipAddingBlocks">
    <div class="animate-show" *ngIf="topRow.length > 0 || bottomRow.length > 0">
        <div [ngClass]="{Squeeze: rowTiles > 5}">
            <div class="TopRow">
                <div class="block_counter" [ngClass]="{IsNeg: topValue < 0}">
					<span *ngIf="noZeroValue(topValue)">
						{{ topValue | numWithSign }}
					</span>
                </div>
                <div class="BlockContainer" *ngFor=" let block of topRow; index as ind"  [ngClass]="{'IsZeroPair': ind < numZeroBlocks}" (click)="removeBlock(topRow, ind)">
                    <div class="Block animated bounceIn" [ngClass]="{'IsNeg': block.value === -1}">{{block.value | numWithSign | minusToDash}}</div>
                </div>
            </div>
            <div class="BottomRow">
                <div class="block_counter" [ngClass]="{IsNeg: bottomValue < 0}">
                    <span *ngIf="noZeroValue(bottomValue)">{{bottomValue | numWithSign | minusToDash}}</span>
                </div>
                <div class="BlockContainer" *ngFor=" let block of bottomRow; index as ind" [ngClass]="{'IsZeroPair': ind < numZeroBlocks}" (click)="removeBlock(bottomRow, ind)">
                    <div class="Block animated bounceIn" [ngClass]="{'IsNeg': block.value === -1}">{{block.value | numWithSign | minusToDash}}</div>
                </div>
            </div>
            <div class="BlockZeroSum IsZeroPair BlockZeroSum-{{numZeroBlocks}}" *ngIf="numZeroBlocks > 0">
                <span *ngIf="numZeroBlocks > 1">{{numZeroBlocks}} + (–{{numZeroBlocks}})</span> = 0
            </div>
        </div>

        <div class="BlockSummary">
            {{value | minusToDash}} <!--= {{Total}}-->
        </div>
    </div>
    <div *ngIf="!(hideStudentManipControlBar | async)"
        class="ManipAlgebraTilesBar StudentManipControlBar StudentManipControlBarBottomOnMobile">
        <div class="kh-bottom-bar-container w-100 d-flex justify-content-center align-content-center kh-horizontal-scroll-bar ">
            <div
                class="kh-bottom-bar-content-container w-100 d-flex justify-content-between align-items-center  flex-shrink-0">
                <div class="w-100 d-flex align-items-center   flex-shrink-0 flex-grow-1">
                    <div class=" d-flex align-items-center kh-justify-content-align-controls  flex-shrink-0 flex-grow-1">
                        <button #add type="button" *ngIf="isOppositeSigns" (click)="AddBlock(topRow, 1)"
                            class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls">
                            {{ 'MANIP_ADDINGBLOCKS.ADD_POSITIVE_ONE' | translate }}
                        </button>
                        <button #substract type="button" *ngIf="isOppositeSigns" (click)="AddBlock(bottomRow, -1)"
                            class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls">
                            {{ 'MANIP_ADDINGBLOCKS.ADD_NEGATIVE_ONE' | translate }}
                        </button>
                        <button #sameSign type="button" *ngIf="isSameSigns" (click)="AddBlock(bottomRow, blockValue)"
                            class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls">
                            {{ 'MANIP_ADDINGBLOCKS.ADD_VALUE' | translate: { value: blockValueFormatted } }}
                        </button>
                        <button #reset type="button"
                            class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls mr-2"
                            (click)="resetClick()"><fa-icon [icon]="['fas','redo']" class="mr-2"></fa-icon>{{ 'MANIP_ADDINGBLOCKS.RESET' | translate }}</button>
                    </div>
                    <div class="justify-content-end kh-submit-width  flex-shrink-0 ">
                        <button
                            class="btn-md kh-green-button kh-green-accessible white kh-lg-title-text text-uppercase kh-no-wrap  manipulative-submit-button  "
                            type="button" *ngIf="isManipChanged && !questionClosed" (click)="submit()"
                            [class.animated]="isManipChanged"><img
                                src="https://staticcontent.knowledgehook.com/content/icons/question/submitarrow-onprimary.svg">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
